<template>
  <div>
    <layout-desktop v-if="!isMobile"
                    :category="categoryTemp"
                    :filters="filtersTemp"
                    :articles="articlesTemp"
                    :articlesEven="articlesEvenTemp"
                    :articlesOdd="articlesOddTemp"/>
    <layout-mobile v-if="isMobile"
                   :category="categoryTemp"
                   :filters="filtersTemp"
                   :articles="articlesTemp"/>

    <div class="pagination" v-if="pagination['next_page_url']">
      <ul>
        <li v-if="pagination['prev_page_url']" class="prev-page">
          <a :href="pagination['prev_page_url']">Anterior</a>
        </li>
        <li class="current-page">
          <span>{{ pagination['current_page'] }}</span>
        </li>
        <li v-if="pagination['next_page_url']" class="next-page">
          <a :href="pagination['next_page_url']">Seguinte</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import LayoutOfPageInDesktop from "./layout-desktop";
import LayoutOfPageInMobile from "./layout-mobile";

export default {
  components: {
    'layout-desktop': LayoutOfPageInDesktop,
    'layout-mobile': LayoutOfPageInMobile,
  },
  data: () => ({
    isMobile: false,
    categoryTemp: [],
    filtersTemp: [],
    articlesTemp: [],
    articlesEvenTemp: [],
    articlesOddTemp: [],
    pagination: [],
    xhrLoadDataEventFn: null,
  }),

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, {passive: true})
    }
  },

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true});

    const ownElem = this;

    window.addEventListener('load', function (event) {

      ownElem.categoryTemp = window.data;
      ownElem.filtersTemp = window.data.filters;

      ownElem.articlesTemp = window.data.paginatedArticles['articles'];
      ownElem.pagination = window.data.paginatedArticles['paginator'];


      for (let i = 0; i < ownElem.articlesTemp.length; i++) {
        if (i % 2 == 0) {
          ownElem.articlesEvenTemp.push(ownElem.articlesTemp[i]);
        } else {
          ownElem.articlesOddTemp.push(ownElem.articlesTemp[i]);
        }
      }
    });

    const url = new URL(window.location);

    this.selected_family = url.searchParams.get('category') ?? this.categoryTemp.id;
    this.selected_family = url.searchParams.get('filter') ?? 'all';
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 991.98
    },
    handleClickedFilters(evt, id) {
      let element = evt.target;

      const url = new URL(window.location);
      url.searchParams.set('category', this.categoryTemp.id);
      url.searchParams.set('filter', id);

      window.history.pushState({}, '', url);

      if (this.xhrLoadDataEventFn != null) {
        clearTimeout(this.xhrLoadDataEventFn);
      }
      this.xhrLoadDataEventFn = setTimeout(() => {
        const xhr = new window.fetchdata();
        const fullUrl = `${baseUrl}/ajaxservice/get-articles-by-filter?category=${this.categoryTemp.id}&filter=${id}`;
        xhr.fetchData(
          fullUrl,
          'GET',
          undefined,
          (result) => {
            console.log(result);
            this.articlesTemp = [];
            this.articlesEvenTemp = [];
            this.articlesOddTemp = [];
            this.pagination = [];
            this.articlesTemp = result.articles;

            for (let i = 0; i < this.articlesTemp.length; i++) {
              if (i % 2 == 0) {
                this.articlesEvenTemp.push(this.articlesTemp[i]);
              } else {
                this.articlesOddTemp.push(this.articlesTemp[i]);
              }
            }

            this.pagination = result.paginator;

            Array.from(document.querySelectorAll('span.value-filter')).forEach(function (el) {
              el.classList.remove('active');
            });

            if (element.getAttribute("data-id") !== 'all') {
              element.classList.add('active');
            }

          },
          (result) => {
            console.error(result);
          }
        );
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>
